import { render, staticRenderFns } from "./DuplicateConnection.vue?vue&type=template&id=367eda8a&scoped=true"
import script from "./DuplicateConnection.vue?vue&type=script&scoped=true&lang=js"
export * from "./DuplicateConnection.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./DuplicateConnection.vue?vue&type=style&index=0&id=367eda8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367eda8a",
  null
  
)

export default component.exports